import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../state'
import * as content from '../../../../../content'

/** Creates and edits connector definitions as JSON. */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.code.Component,
    ds.input.text.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.value.Component,
    content.admin.errorMessage.Component,
  ],
  selector: 'atn-integration-definition-modal',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Connector definitions for the active Admin zone. */
  public readonly definitionsEc = ngCore.inject(
    state.integrations.connectorDefinitions.Collection,
  )

  /** Writes a valid JSON definition payload into the current editing draft. */
  public definitionChangeHandler(value: unknown): void {
    if (
      !TypeChecker.isObject(value) ||
      !('imports' in value) ||
      !Array.isArray(value.imports) ||
      !value.imports.every(
        ents.core.integrations.Connector.Definition.Import.isImport,
      )
    ) {
      return
    }
    const imports = value.imports
    this.definitionsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationDefinition.Dialog.Json.Changed')
      .dispatch({
        edit: definition => {
          if (definition) {
            definition.imports = imports
          }
        },
      })
  }

  /** Writes the human-readable name into the current definition draft. */
  public nameChangeHandler(name: string): void {
    this.definitionsEc.plugins.editingPlugin.feature.actions.edit
      .from('IntegrationDefinition.Dialog.Name.Changed')
      .dispatch({
        edit: definition => {
          if (definition) {
            definition.name = name
          }
        },
      })
  }

  /** Submits the current definition draft. */
  public save(): void {
    this.definitionsEc.plugins.editingPlugin.feature.actions.submit
      .from('IntegrationDefinition.Dialog.Save.Clicked')
      .dispatch({ current: true, skipUnset: true })
  }

  /** Discards the current definition draft. */
  public cancel(): void {
    this.definitionsEc.plugins.editingPlugin.feature.actions.discard
      .from('IntegrationDefinition.Dialog.Cancel.Clicked')
      .dispatch({ current: true, skipUnset: true })
  }
}
